import React from 'react';

    /*
    * Logo officiel Erpia : « E » italique rouge dont la barre centrale porte
    * une croix suisse crème. Reconstruction vectorielle du logo fourni par le
    * client — un E droit dessiné en rectangles puis incliné d'environ 10°
    * (matrice de cisaillement centrée), croix aux proportions de l'original
    * (elle occupe presque toute la hauteur de la barre). Les couleurs sont
    * celles du logo, portées par les jetons --erp-logo-red / --erp-logo-cross :
    * un drapeau ne s'inverse pas, elles valent en clair comme en nuit.
    */
    export default function ErpiaBrand({ variant = 'sidebar', className = '' }) {
      return <span className={'erpia-brand erpia-brand-' + variant + (className ? ' ' + className : '')} role="img" aria-label="erpia">
        <span className="erpia-brand-mark" aria-hidden="true"><svg viewBox="0 0 28 28" role="presentation" focusable="false">
          <g transform="matrix(1,0,-0.176,1,2.469,0)">
            <g fill="var(--erp-logo-red, currentColor)">
              <rect x="6" y="3" width="4.6" height="22" />
              <rect x="6" y="3" width="17.5" height="4.6" />
              <rect x="6" y="11.7" width="14.8" height="4.6" />
              <rect x="6" y="20.4" width="16.5" height="4.6" />
            </g>
            <g fill="var(--erp-logo-cross, var(--accent-fg))">
              <rect x="13.78" y="11.85" width="1.45" height="4.3" />
              <rect x="12.35" y="13.28" width="4.3" height="1.45" />
            </g>
          </g>
        </svg></span>
        {/* Le grand E EST la première lettre : le mot n'écrit que « rpia. » —
            le lockup se lit « Erpia. » d'un seul bloc (demande client). */}
        <span className="erpia-brand-word" aria-hidden="true">rpia<span className="erpia-brand-punctuation">.</span></span>
      </span>;
    }
